import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Copy, Eye, EyeOff } from "lucide-react";
import { adminApi, AdminHeader } from "@/lib/adminApi";

const API = process.env.REACT_APP_BACKEND_URL;

const sample = (key) => `curl -X POST ${API}/api/admin/signals/ingest \\
  -H "Content-Type: application/json" \\
  -H "X-API-Key: ${key}" \\
  -d '{
    "title": "OpenAI launches enterprise agent platform",
    "source": "OpenAI",
    "source_url": "https://openai.com/blog",
    "summary": "Short factual summary of what happened.",
    "category": "Artificial Intelligence",
    "relevance_score": 8,
    "adaptive_intelligence_relevance": "Why it matters for human decision-making.",
    "suggested_angle": "Editorial angle for Raulvin",
    "suggested_headline": "AI Agents Become Enterprise Infrastructure",
    "draft_article": "Full AI-generated draft..."
  }'`;

const copy = (text) => { navigator.clipboard.writeText(text); toast.success("Copied"); };

const AdminAutomation = () => {
  const [info, setInfo] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => { adminApi("/admin/automation").then(setInfo).catch((e) => toast.error(e.message)); }, []);
  if (!info) return <div className="text-[var(--text-secondary)]">Loading...</div>;
  const masked = show ? info.api_key : "•".repeat(24);

  return (
    <div className="max-w-4xl">
      <AdminHeader title="Automation" subtitle="Connect Manus, n8n, Make or Zapier to push signals into your inbox" testId="automation-heading" />
      <div className="bg-[var(--bg-card)] border-glow rounded-xl p-6 space-y-5">
        <div>
          <p className="text-xs uppercase tracking-wider text-[var(--text-secondary)] mb-1.5">Webhook endpoint</p>
          <div className="flex items-center gap-2">
            <code className="flex-1 text-sm text-[var(--accent-violet-light)] bg-[var(--bg-secondary)] rounded-lg px-3 py-2 break-all" data-testid="automation-endpoint">POST {API}{info.ingest_path}</code>
            <button onClick={() => copy(`${API}${info.ingest_path}`)} className="p-2 text-[var(--text-secondary)] hover:text-white" data-testid="copy-endpoint-btn"><Copy className="w-4 h-4" /></button>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider text-[var(--text-secondary)] mb-1.5">Header: {info.header}</p>
          <div className="flex items-center gap-2">
            <code className="flex-1 text-sm text-white bg-[var(--bg-secondary)] rounded-lg px-3 py-2 break-all" data-testid="automation-api-key">{masked}</code>
            <button onClick={() => setShow(!show)} className="p-2 text-[var(--text-secondary)] hover:text-white" data-testid="toggle-api-key-btn">{show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
            <button onClick={() => copy(info.api_key)} className="p-2 text-[var(--text-secondary)] hover:text-white" data-testid="copy-api-key-btn"><Copy className="w-4 h-4" /></button>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider text-[var(--text-secondary)] mb-1.5">Example request</p>
          <pre className="text-xs text-[var(--text-secondary)] bg-[var(--bg-secondary)] rounded-lg p-4 overflow-x-auto" data-testid="automation-sample">{sample(masked)}</pre>
        </div>
      </div>
    </div>
  );
};

export default AdminAutomation;
